import { render } from "./Gallographic-gallery.vue?vue&type=template&id=52616526&scoped=true"
import script from "./Gallographic-gallery.vue?vue&type=script&lang=js"
export * from "./Gallographic-gallery.vue?vue&type=script&lang=js"

import "./Gallographic-gallery.vue?vue&type=style&index=0&id=52616526&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52616526"]])

export default __exports__